import { Icon } from "@iconify/react";
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getNotifications } from "../../redux/notification/notificationSlice";
import { getLoggedInUserInfo } from "../../redux/auth/authApi";
import Avatar from "../../components/Avtar/Avatar";

const HeaderNotificationComponent = () => {
  const [open, setOpen] = useState(false);
  const loggedInUserInfo = getLoggedInUserInfo();
  const isLoggedInSponsor = loggedInUserInfo?.Role?.name === "SPONSOR";
  const ref = useRef();
  const [hasFetched, setHasFetched] = useState(false);

  const dispatch = useDispatch();
  const isSponsor = loggedInUserInfo?.Role?.name === "SPONSOR";
  const { notifications = [] } = useSelector((state) => state.notification);

  const toggleDropdown = () => {
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!hasFetched && isSponsor) {

      if (!notifications || notifications.length === 0) {
        dispatch(getNotifications({
          isSponsor: isLoggedInSponsor,
        }));
      }
      setHasFetched(true);

    }
  }, [dispatch, notifications.length]);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  if (!isSponsor) return null;
  return (
    <div className="position-relative" ref={ref}>
      <button
        onClick={toggleDropdown}
        className="position-relative has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center border-0"
      >
        <Icon icon="mage:email" className="text-primary-light text-xl" />


        {notifications.length > 0 && (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            style={{ fontSize: "10px" }}
          >
            {notifications.length}
          </span>
        )}
      </button>

      {open && (
        <div className="dropdown-menu show to-top dropdown-menu-lg p-0 shadow-lg border-0">

          <div className="py-12 px-16 bg-primary-50 d-flex align-items-center justify-content-between">
            <h6 className="text-lg text-primary-light fw-semibold mb-0">
              Requests
            </h6>

            <span className="text-primary-600 fw-semibold text-sm w-32-px h-32-px rounded-circle bg-white d-flex justify-content-center align-items-center">
              {notifications.length}
            </span>
          </div>

          <div className="max-h-400-px overflow-y-auto scroll-sm">

            {notifications.length === 0 && (
              <div className="text-center py-20 text-secondary-light">
                No Requests
              </div>
            )}

            {notifications.slice(0, 5).map((notification) => (
              <Link
                key={notification.id}
                to="#"
                className="d-flex justify-content-between align-items-start gap-3 px-16 py-12 border-bottom hover-bg-light"
              >
                <div className="d-flex align-items-start gap-3">

                  <span className="w-44-px h-44-px rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">

                    <Avatar
                      name={notification.title}
                      image={notification.image}
                      uniqueKey={notification.id}
                      size={28}
                    />
                  </span>

                  <div>
                    <h6 className="text-sm fw-semibold mb-2">
                      {notification.title}
                    </h6>
                    <p className="text-xs text-secondary-light mb-0">
                      {notification.body}
                    </p>
                  </div>
                </div>

                <span className="text-xs text-secondary-light flex-shrink-0">
                  {new Date(notification.createdAt).toLocaleDateString()}
                </span>
              </Link>
            ))}
          </div>

          <div className="text-center py-10 border-top">
            {/* <Link
              to="#"
              className="text-primary-600 fw-semibold text-sm"
            >
              See All Requests
            </Link> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderNotificationComponent;